import {Tooltip} from '@dropbox/dig-components/tooltips';
import {Text} from '@dropbox/dig-components/typography';
import {Box} from '@dropbox/dig-foundations';
import type {RedactedWorkstreamMetric, WorkstreamMetric} from 'client';
import {StatusButtonIcon} from 'components/DSYS/StatusButtonIcon';
import {useMemo} from 'react';
import {getFullWorkstreamMetrics} from 'views/workstreams/utils';

import {getNorthStarItem, type ProgressItem} from './scanProgressItems';

/** The workstream's starred north star, as the open card pins it. */
export const useNorthStarItem = (workstream: {
  id: number;
  metrics: Array<WorkstreamMetric | RedactedWorkstreamMetric>;
}) =>
  useMemo(
    () => getNorthStarItem(workstream.id, getFullWorkstreamMetrics(workstream.metrics)),
    [workstream.id, workstream.metrics]
  );

/**
 * A collapsed card's north star at the end of its byline: its status and value
 * against plan, the metric's name on hover. An open card drops it: its north
 * star box says the same.
 *
 *   Bryan Lovgren · 2w ago · ● $2.8M of $4M
 */
export const NorthStarByline = ({item}: {item: ProgressItem}) => {
  if (!item.value) return null;
  const {current, plan} = item.value;
  return (
    <Tooltip title={item.title} placement="top">
      <Box display="flex" alignItems="center" style={{gap: 4, flexShrink: 0}}>
        <Box display="flex">
          <StatusButtonIcon status={item.status} size="xsmall" includeArchived />
        </Box>
        <Text size="small" color="faint" style={{whiteSpace: 'nowrap'}}>
          {plan ? `${current} of ${plan}` : current}
        </Text>
      </Box>
    </Tooltip>
  );
};
